import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Badge, Icon, Tooltip } from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { useHistory } from 'react-router-dom';
import PrimaryTheme from '../Themes/Primary';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      padding: 0
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
  }),
);

export default function DenseAppBar(props: AppBarProps) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      <AppBar position="static" color="transparent" elevation={0} >
        <Toolbar variant="regular" style={{
          padding: 0
        }} >
          <div className="row m-0 justify-content-between w-100 align-items-center">
            <div>
              {props.hasHamburger && <IconButton edge="start" className={classes.menuButton + " d-md-none mr-1"} color="inherit" aria-label="menu" onClick={props.onMenuClick}>
                <MenuIcon />
              </IconButton>}

              {props.canGoBack &&
                <Tooltip title="Go back">
                  <IconButton aria-label="Go back" onClick={() => history.goBack()} style={{
                    background: "#E6F4FC",
                  }}>
                    <Icon fontSize="small" style={{
                      color: PrimaryTheme.primary
                    }}>arrow_back</Icon>
                  </IconButton>
                </Tooltip>}
            </div>
            <div>

            </div>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}

interface AppBarProps {
  canGoBack?: boolean;
  hasHamburger?: boolean;
  onClick?: any;
  onMenuClick?: any;
}
